import { Controller } from "@hotwired/stimulus";
import "@videojs/html/video/skin";

// Wraps <video-player> web component from @videojs/html.
// The controller lives on the wrapper div; the <video-player> inside is
// declarative — no manual init needed. We only handle Turbo lifecycle.
export default class extends Controller {
  connect() {
    this.originalHTML = this.element.innerHTML;
    this.beforeCache = () => this.teardown();
    document.addEventListener("turbo:before-cache", this.beforeCache);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache);
    this.teardown();
  }

  teardown() {
    if (this.originalHTML != null) {
      this.element.innerHTML = this.originalHTML;
      this.originalHTML = null;
    }
  }
}
